import { deleteCall, getCall, postCall } from "../../networking";
import { catalogueUrls, salesUrls } from "../../networking/url";
import * as types from "../actions/types/catalogue.types";
import { SHOW_EXPIRED_MODAL } from "../actions/types/app.types";

export const createCatalogueItem = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.catalogueItem, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const addCatalogueCategory = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.catalogueCategory, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const getCatalogueCategories = (params) => async (dispatch) => {
    dispatch({ type: types.FETCH_CATALOGUE_CATEGORY_STARTED });

    try {
        const response = await getCall(catalogueUrls.catalogueCategory, params);
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_CATALOGUE_CATEGORY_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_CATALOGUE_CATEGORY_FAILED, payload: [] });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_CATALOGUE_CATEGORY_FAILED,
            message: "Error fetching catalogue categories",
        });
    }
};

export const getCatalogueItems = (params) => async (dispatch) => {
    dispatch({ type: types.FETCH_CATALOGUE_ITEMS_STARTED });

    try {
        const response = await getCall(catalogueUrls.catalogueItem, params);
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_CATALOGUE_ITEMS_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_CATALOGUE_ITEMS_FAILED, payload: [] });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_CATALOGUE_ITEMS_FAILED,
            message: "Error fetching catalogue items",
        });
    }
};

export const editCatalogueItem = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.editCatalogueItem, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const deleteCatalogueItem = (ownerId, id) => async (dispatch) => {
    try {
        const response = await deleteCall(catalogueUrls.deleteCatalogueItem(ownerId, id));
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const editCategory = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.editCategory, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const deleteCategory = (ownerId, id) => async (dispatch) => {
    try {
        const response = await deleteCall(catalogueUrls.deleteCategory(ownerId, id));
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const getCatalogueStatus = (params) => async (dispatch) => {
    dispatch({ type: types.GET_CATALOGUE_STATUS_STARTED });

    try {
        const response = await getCall(catalogueUrls.activationStatus, params);

        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.GET_CATALOGUE_STATUS_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.GET_CATALOGUE_STATUS_FAILED, payload: null });
        }
    } catch (err) {
        dispatch({
            type: types.GET_CATALOGUE_STATUS_FAILED,
            message: "Error fetching catalogue status",
        });
    }
};

export const activateCatalogue = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.activationStatus, data);
        if (!response) {
            dispatch({ type: SHOW_EXPIRED_MODAL });
        } else if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const createSalesToken = (data) => async (dispatch) => {
    try {
        const response = await postCall(salesUrls.generateSalesToken, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const getSalesToken = (payload) => async (dispatch) => {
    dispatch({ type: types.FETCH_SALES_DEVICES_STARTED });

    try {
        const response = await postCall(salesUrls.getSalesDevices, payload);
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_SALES_DEVICES_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_SALES_DEVICES_FAILED, payload: [] });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_SALES_DEVICES_FAILED,
            message: "Error fetching sales devices",
        });
    }
};

export const deleteSalesDevice = (data) => async (dispatch) => {
    try {
        const response = await postCall(salesUrls.deleteSalesDevice, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const disableSalesDevice = (data) => async (dispatch) => {
    try {
        const response = await postCall(salesUrls.deactivateSalesDevice, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const enableSalesDevice = (data) => async (dispatch) => {
    try {
        const response = await postCall(salesUrls.reactivateSalesDevice, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const getOrders = (params) => async (dispatch) => {
    dispatch({ type: types.FETCH_ORDER_HISTORY_STARTED });

    try {
        const response = await getCall(catalogueUrls.orderHistory, params);
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_ORDER_HISTORY_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_ORDER_HISTORY_FAILED, payload: [] });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_ORDER_HISTORY_FAILED,
            message: "Error fetching catalogue orders",
        });
    }
};

export const deleteOrder = (ownerId, id) => async (dispatch) => {
    try {
        const response = await deleteCall(catalogueUrls.deleteOrder(ownerId, id));
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};
